import { GlobalHeaderDropDown } from "@/components/molecules/GlobalHeaderDropDown";

import useFixedAuth from "@/libs/useFixedAuth";

export const HelpDropDown = () => {
  return (
    <GlobalHeaderDropDown>
      <GlobalHeaderDropDown.Header icon="help">
        ヘルプ
      </GlobalHeaderDropDown.Header>
      <GlobalHeaderDropDown.Body width={200}>
        <HelpDropDownItems />
      </GlobalHeaderDropDown.Body>
    </GlobalHeaderDropDown>
  );
};

export const HelpDropDownItems = ({ showSeparator = true }) => {
  const { userInfo } = useFixedAuth();
  const isAdmin = userInfo.authority === "admin";

  return (
    <>
      <GlobalHeaderDropDown.ItemLink
        href="https://support.id.x.moneyforward.com/hc/ja"
        icon="openInNew"
        openInNewTab={true}
      >
        よくある質問
      </GlobalHeaderDropDown.ItemLink>
      {isAdmin && (
        <>
          {showSeparator && <GlobalHeaderDropDown.Separator />}
          <GlobalHeaderDropDown.ItemLink
            href="/feedback/new"
            icon="openInNew"
            openInNewTab={true}
          >
            お問い合わせ
          </GlobalHeaderDropDown.ItemLink>
        </>
      )}
    </>
  );
};
